import { render, staticRenderFns } from "./stateTotal.vue?vue&type=template&id=4bd73d6c&scoped=true&"
import script from "./stateTotal.vue?vue&type=script&lang=js&"
export * from "./stateTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd73d6c",
  null
  
)

export default component.exports